// extracted by mini-css-extract-plugin
export default {"popupview":"b726ba3f8d303a7526d0"};